import React, { Component, Suspense, lazy } from "react";
import CacheBuster from "./CacheBuster";

import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import WaveLoad from "./images/Wave_Load.svg";
// Preload critical route CSS to avoid first-visit FOUC after code-splitting
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./container/admin/IARedesign/InvestorLogins/Summary/DealSummary.css";
import "./container/admin/IARedesign/InvestorLogins/Summary/DataDisplaySummary.css";
import "./container/admin/IARedesign/InvestorLogins/Summary/UnifiedDashboard.css";
import "./container/admin/IARedesign/InvestorLogins/Summary/StratsDropDowns.css";
import "./container/admin/IARedesign/InvestorLogins/Summary/DealAnalyticsLoans.css";
import "./container/admin/IARedesign/InvestorLogins/Summary/SummaryWidgetBoard.css";
import "./container/admin/IARedesign/InvestorLogins/WidgetDashboard/WidgetDashboard.css";
import "./container/admin/IARedesign/InvestorLogins/Standard/PortfolioStandard.css";
import "./container/admin/IARedesign/InvestorLogins/Standard/DataDisplay.css";
import "./container/admin/IARedesign/InvestorLogins/Capital Structures/capitalStructures.css";
import "./container/admin/IARedesign/InvestorLogins/Risk_Compliance/index.css";
import "./container/admin/IARedesign/DealCreation/CommonCreation.css";

import ScrollToTop from "./components/scrollToTop";
import setUpAxios from "./interceptor";
import { SnackbarProvider } from "notistack";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import LayoutRoute from "./container/LayoutRoute";
import LoginLayoutRoute from "./container/LoginLayoutRoute";
import ErrorPage from "./components/custom_404";
import { ToastContainer, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./container/admin/Login/login";

const UpdateProfile = lazy(() => import("./container/admin/UpdateProfile/UpdateProfile"));
const Users = lazy(() => import("./container/admin/users/Users"));
// Prefetch trustee dashboard chunk to reduce first-load delay after login
const Dashboard = lazy(() =>
  import(
     "./container/admin/IARedesign/DealCreation/Dashboard/Dashboard"
  )
);
const Tranches_DealCreation = lazy(() => import("./container/admin/IARedesign/DealCreation/Tranches/Tranches"));
const PaymentRules_DealCreation = lazy(() => import("./container/admin/IARedesign/DealCreation/PaymentRules/PaymentRules"));
const Variables_DealCreation = lazy(() => import("./container/admin/IARedesign/DealCreation/Variables/Variables"));
const General_DealCreation = lazy(() => import("./container/admin/IARedesign/DealCreation/General/General"));
const Account_DealCreation = lazy(() => import("./container/admin/IARedesign/DealCreation/Account/Account"));
const Fees_DealCreation = lazy(() => import("./container/admin/IARedesign/DealCreation/Fees/Fees"));
const Test_DealCreation = lazy(() => import("./container/admin/IARedesign/DealCreation/Tests/Tests"));
const Expense_DealCreation = lazy(() => import("./container/admin/IARedesign/DealCreation/Expenses/Expenses"));
const General_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/General_Recurring/General_Recurring"));
const Tranches_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/Tranches_Recurring/Tranches_Recurring"));
const ServicerMainDashboard = lazy(() => import("./container/admin/IARedesign/Servicer/ServicerDashboard"));
const UploadLoanTape = lazy(() => import("./container/admin/IARedesign/LoanProcessing/UploadLoantape/UploadLoanTape"));
const ViewDetails_Deal = lazy(() => import("./container/admin/IARedesign/ViewDealDetails/ViewDetails/ViewDetails"));
const Preview_LoanTape = lazy(() => import("./container/admin/IARedesign/LoanProcessing/Preview_LoanTapeDetails/Preview_LoanTapeDetails"));
const Preview_Mapped_fields = lazy(() => import("./container/admin/IARedesign/LoanProcessing/PreviewMapFields/PreviewMapFields"));
const Map_Fields = lazy(() => import("./container/admin/IARedesign/LoanProcessing/MapFields/MapFields"));
const Summarize_Servicer = lazy(() => import("./container/admin/IARedesign/LoanProcessing/Summarize/Summarize"));
const Fees_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/Fees_Recurring/Fees_Recurring"));
const Expenses_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/Expenses_Recurring/Expenses_Recurring"));
const Variable_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/Variable_Recurring/Variable_Recurring"));
const Tests_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/Tests_Recurring/Tests_Recurring"));
const Payment_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/Payment_Recurring/Payment_Recurring"));
const Accounts_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/Accounts_Recurring/Accounts_Recurring"));
const CollateralReport = lazy(() => import("./container/admin/IARedesign/DealRecurring/CollateralReport/CollateralReport"));
const InvestorReport = lazy(() => import("./container/admin/IARedesign/DealRecurring/InvestorReport/InvestorReport"));
const BDBReport = lazy(() => import("./container/admin/IARedesign/DealRecurring/BDBReport/BDBReport"));
const InvestorDashboard = lazy(() => import("./container/admin/IARedesign/InvestorLogins/InvestorDashboard/InvestorDashboard"));
const LoanTapeRecurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/LoanTapeRecurring/LoanTapeRecurring"));
const ConsolidatedRecurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/ConsolidatedRecurring/ConsolidatedRecurring"));
const Register = lazy(() => import("./container/admin/Register/Register"));
const Files_Recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/Files_Recurring/Files_Recurring"));
const Collateral_InvRecurring = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Collateral_InvRecurring/Collateral_InvRecurring"));
const Report_InvRecurring = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Report_InvRecurring/Report_InvRecurring"));
const Files_InvRecurring = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Files_Inv/Files_Inv"));
const LoanTapes_InvRecurring = lazy(() => import("./container/admin/IARedesign/InvestorLogins/LoanTapes_InvRecurring/LoanTapes_InvRecurring"));
const Standard = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Standard/Standard"));
const StdFields = lazy(() => import("./container/admin/StdFields/StdFields"));
const On_Demand = lazy(() => import("./container/admin/IARedesign/InvestorLogins/On_Demand/On_Demand"));
const IssuerDashboard = lazy(() => import("./container/admin/IARedesign/IssuerLogins/IssuerDashboard/IssuerDashboard"));
const On_Demand_Issuer = lazy(() => import("./container/admin/IARedesign/IssuerLogins/On_Demand_Issuer/On_Demand_Issuer"));
const DealAnalytics = lazy(() => import("./container/admin/IARedesign/IssuerLogins/DealAnalytics/DealAnalytics"));
const PortfolioAnalytics = lazy(() => import("./container/admin/IARedesign/IssuerLogins/PortfolioAnalytics/PortfolioAnalytics"));
const Report_IssuerRecurring = lazy(() => import("./container/admin/IARedesign/IssuerLogins/Report_IssuerRecurring/Report_IssuerRecurring"));
const Collateral_IssuerRecurring = lazy(() => import("./container/admin/IARedesign/IssuerLogins/Collateral_IssuerRecurring/Collateral_IssuerRecurring"));
const LoanTapes_IssuerRecurring = lazy(() => import("./container/admin/IARedesign/IssuerLogins/LoanTapes_IssuerRecurring/LoanTapes_IssuerRecurring"));
const Files_IssuerRecurring = lazy(() => import("./container/admin/IARedesign/IssuerLogins/Files_IssuerRecurring/Files_IssuerRecurring"));
const BorrowingBase = lazy(() => import("./container/admin/IARedesign/DealCreation/BorrowingBase/BorrowingBase"));
const BorrowingBaseRecurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/BorrowingBaseRecurring/BorrowingBaseRecurring"));
const Annex = lazy(() => import("./container/admin/IARedesign/DealCreation/Esma_Reporting/Annex"));
const Annex12 = lazy(() => import("./container/admin/IARedesign/DealCreation/Esma_Reporting/Annex12"));
const Annex14 = lazy(() => import("./container/admin/IARedesign/DealCreation/Esma_Reporting/Annex14"));
const Annex_Inv = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Esma_Inv_Reporting/Annex_Inv"));
const Annex12_Inv = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Esma_Inv_Reporting/Annex12_Inv"));
const Annex14_Inv = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Esma_Inv_Reporting/Annex14_Inv"));
const Manual_Input = lazy(() => import("./container/admin/IARedesign/DealCreation/ManualInput/Manual_Input"));
const ManualInput_recurring = lazy(() => import("./container/admin/IARedesign/DealRecurring/ManualInput_Recuring/ManualInput_recurring"));
const UploadClosing_Loantape = lazy(() => import("./container/admin/IARedesign/ClosingLoanProcessing/UploadClosing_Loantape/UploadClosing_Loantape"));
const PreviewClosing_LoanTapeDetails = lazy(() => import("./container/admin/IARedesign/ClosingLoanProcessing/PreviewClosing_LoanTapeDetails/PreviewClosing_LoanTapeDetails"));
const Closing_MapFields = lazy(() => import("./container/admin/IARedesign/ClosingLoanProcessing/Closing_MapFields/Closing_MapFields"));
const PreviewClosing_MapFields = lazy(() => import("./container/admin/IARedesign/ClosingLoanProcessing/PreviewClosing_MapFields/PreviewClosing_MapFields"));
const DealAnalyticsSummary = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Summary/DealAnalyticsSummary"));
const DealAnalyticsStrats = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Summary/DealAnalyticsStrats"));
const DealAnalyticsPerformance = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Summary/DealAnalyticsPerformance"));
const DealAnalyticsLoans = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Summary/DealAnalyticsLoans"));
const PortfolioStandard = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Standard/PortfolioStandard"));
const DealAnalyticsFunding = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Summary/DealAnalyticsFunding"));
const DealAnalyticsPayments = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Summary/DealAnalyticsPayments"));
const DealAnalyticsQC = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Summary/DealAnalyticsQC"));
const RiskOverview = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Risk_Compliance/RiskOverview"));
const Covenants = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Risk_Compliance/Covenants"));
const Triggers = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Risk_Compliance/Triggers"));
const Insights = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Risk_Compliance/Insights"));
const Concentration = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Risk_Compliance/Concentration"));
const DataChecks = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Risk_Compliance/DataChecks"));
const WidgetDashboard = lazy(() => import("./container/admin/IARedesign/InvestorLogins/WidgetDashboard/WidgetDashboard"));
const CapitalStructures = lazy(() => import("./container/admin/IARedesign/InvestorLogins/Capital Structures/Capital Structures"));


const history = createBrowserHistory();

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#FFC000",
      light: "#FFC000",
      dark: "#FFC000",
    },
    secondary: {
      main: "#49ae46",
      light: "#d5f2f0",
      dark: "#2e9a2b",
    },
  },
  props: {
    MuiButton: {
      size: "medium",
    },
    MuiFilledInput: {},
    MuiFormControl: {},
    MuiFormHelperText: {},
    MuiIconButton: {
      size: "medium",
    },
    MuiInputBase: {},
    MuiInputLabel: {},
    MuiListItem: {
      dense: true,
    },
    MuiOutlinedInput: {},
    MuiFab: {
      size: "medium",
    },
    MuiTable: {
      size: "medium",
    },
    MuiTextField: {
      variant: "filled",
      size: "medium",
    },
    MuiToolbar: {
      variant: "dense",
    },
  },

  overrides: {},
});

class App extends Component {
  componentDidMount() {
    setUpAxios();
  }

  render() {
    const isSecuritisation =
      sessionStorage.getItem("isSecuritisation") === "Securitisation";
    // console.log({ isSecuritisation });

    return (
      <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) {
            return (
              <div
                className="page-loading"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "24px",
                  minHeight: "100vh",
                  backgroundColor: "var(--white)",
                }}
              >
                <img
                  src={WaveLoad}
                  alt="Loading"
                  style={{
                    width: "100%",
                    height: "10vh",
                    backgroundColor: "var(--white)",
                  }}
                />
              </div>
            );
          }

          if (!isLatestVersion) {
            refreshCacheAndReload(); // Redirect to the login page when a new version is detected
            return null; // Prevent rendering after redirection
          }

          return (
            <div className="App">
              <ThemeProvider theme={theme}>
                {/* <SnackbarProvider
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  maxSnack={3}
                > */}
                <ToastContainer
                  position="top-right"
                  autoClose={8000}
                  theme={theme.palette.type === "dark" ? "dark" : "light"}
                  toastStyle={{
                    backgroundColor:
                      theme.palette.type === "dark" ? "#1e1e1e" : "#ffffff",
                    color:
                      theme.palette.type === "dark" ? "#ffffff" : "#333333",
                  }}
                  toastClassName="custom-toast"
                  transition={Slide}

                />
                <Router history={history}>
                  <ScrollToTop />
                  <Suspense
                    fallback={
                      <div
                        className="page-loading"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "24px",
                          minHeight: "100vh",
                        }}
                      >
                        <img
                          src={WaveLoad}
                          alt="Loading"
                          style={{
                            width: "100%",
                            height: "10vh",
                            backgroundColor: "var(--white)",
                          }}
                        />
                      </div>
                    }
                  >
                    <Switch>
                      <LoginLayoutRoute
                        exact={true}
                        path="/"
                        component={Login}
                      />
                      <LoginLayoutRoute
                        exact={true}
                        path="/register"
                        component={Register}
                      />
                      <LoginLayoutRoute
                        exact={true}
                        path="/update-profile"
                        component={UpdateProfile}
                      />
                      <LayoutRoute
                        exact={true}
                        pageTitle={"Users"}
                        path="/admin/users/:orgname/:status"
                        component={Users}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/trustee/setup-page"
                        component={StdFields}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/admin/account"
                        component={Account_DealCreation}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/tranches"
                        component={Tranches_DealCreation}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/paymentrules"
                        component={PaymentRules_DealCreation}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/variables"
                        component={Variables_DealCreation}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/general"
                        component={General_DealCreation}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/fees"
                        component={Fees_DealCreation}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/manualinput"
                        component={Manual_Input}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/annex"
                        component={Annex}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/annex12"
                        component={Annex12}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/annex14"
                        component={Annex14}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/tests"
                        component={Test_DealCreation}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/borrowingBase"
                        component={BorrowingBase}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/expenses"
                        component={Expense_DealCreation}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/admin/general_recurring"
                        component={General_Recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/tranches_recurring"
                        component={Tranches_Recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/fees_recurring"
                        component={Fees_Recurring}
                      />
                      {/* //need to start */}
                      <LayoutRoute
                        exact={true}
                        path="/admin/expenses_recurring"
                        component={Expenses_Recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/payment_recurring"
                        component={Payment_Recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/variable_recurring"
                        component={Variable_Recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/tests_recurring"
                        component={Tests_Recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/borrowingbase_recurring"
                        component={BorrowingBaseRecurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/accounts_recurring"
                        component={Accounts_Recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/collateral_recurring"
                        component={CollateralReport}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/loantape_recurring"
                        component={LoanTapeRecurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/consolidated_recurring"
                        component={ConsolidatedRecurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/files_recurring"
                        component={Files_Recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/viewInvestorReport"
                        component={InvestorReport}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/viewBDBReport"
                        component={BDBReport}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/admin/uploadloantape"
                        component={UploadLoanTape}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/previewloantapedetails"
                        component={Preview_LoanTape}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/mapfields"
                        component={Map_Fields}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/previewmapfields"
                        component={Preview_Mapped_fields}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/summarize"
                        component={Summarize_Servicer}
                      />

                      {/* From Start of Closinig Date */}
                      <LayoutRoute
                        exact={true}
                        path="/admin/closing_uploadloantape"
                        component={UploadClosing_Loantape}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/closing_previewloantapedetails"
                        component={PreviewClosing_LoanTapeDetails}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/closing_mapfields"
                        component={Closing_MapFields}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/closing_previewmapfields"
                        component={PreviewClosing_MapFields}
                      />
                      {/* To End of Closinig Date */}

                      <LayoutRoute
                        exact={true}
                        path="/dashboard"
                        component={Dashboard}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/dashboard/servicer"
                        component={ServicerMainDashboard}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/admin/viewdetails"
                        component={ViewDetails_Deal}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/investor/dashboard"
                        component={InvestorDashboard}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/issuer/dashboard"
                        component={IssuerDashboard}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/report_InvRecurring"
                        component={Report_InvRecurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/collateral_InvRecurring"
                        component={Collateral_InvRecurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/file_InvRecurring"
                        component={Files_InvRecurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/loantape_InvRecurring"
                        component={LoanTapes_InvRecurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/standard_investor"
                        component={Standard}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/ondemand_investor"
                        component={On_Demand}
                      />

                      {/* Check for Sample Demos */}

                      {/* StartDemos */}
                      <LayoutRoute
                        exact={true}
                        path="/investor/standardAnalytics"
                        component={PortfolioStandard}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/capitalStructures"
                        component={CapitalStructures}
                      />
                      {!isSecuritisation ? (
                        <LayoutRoute
                          exact={true}
                          path="/investor/fundingAnalytics"
                          component={DealAnalyticsFunding}
                        />
                      ) : (
                        <LayoutRoute
                          exact={true}
                          path="/investor/summaryAnalytics"
                          component={DealAnalyticsSummary}
                        />
                      )}

                      <LayoutRoute
                        exact={true}
                        path="/investor/paymentAnalytics"
                        component={DealAnalyticsPayments}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/QCAnalytics"
                        component={DealAnalyticsQC}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/investor/stratsAnalytics"
                        component={DealAnalyticsStrats}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/performanceAnalytics"
                        component={DealAnalyticsPerformance}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/loansAnalytics"
                        component={DealAnalyticsLoans}
                      />
                      {/* EndDemos */}
                      <LayoutRoute
                        exact={true}
                        path="/issuer/report_IssuerRecurring"
                        component={Report_IssuerRecurring}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/issuer/collateral_IssuerRecurring"
                        component={Collateral_IssuerRecurring}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/issuer/loantape_IssuerRecurring"
                        component={LoanTapes_IssuerRecurring}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/admin/manualinput_recurring"
                        component={ManualInput_recurring}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/issuer/file_IssuerRecurring"
                        component={Files_IssuerRecurring}
                      />

                      <LayoutRoute
                        exact={true}
                        path="/issuer/standard_issuer"
                        component={PortfolioAnalytics}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/issuer/ondemand_issuer"
                        component={On_Demand_Issuer}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/issuer/dealAnalytics"
                        component={DealAnalytics}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/Annex_Inv"
                        component={Annex_Inv}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/Annex12_Inv"
                        component={Annex12_Inv}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/Annex14_Inv"
                        component={Annex14_Inv}
                      />

                      {/* Widget Dashboard */}
                      <LayoutRoute
                        exact={true}
                        path="/investor/widgetDashboard"
                        component={WidgetDashboard}
                      />

                      {/* Risk Overview */}
                      <LayoutRoute
                        exact={true}
                        path="/investor/riskOverview"
                        component={RiskOverview}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/triggers"
                        component={Covenants}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/insights"
                        component={Insights}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/concentration"
                        component={Concentration}
                      />
                      <LayoutRoute
                        exact={true}
                        path="/investor/DataChecks"
                        component={DataChecks}
                      />




                      <LayoutRoute
                        exact={true}
                        path="*"
                        component={ErrorPage}
                      />
                    </Switch>
                  </Suspense>
                </Router>
                {/* </SnackbarProvider> */}
              </ThemeProvider>
            </div>
          );
        }}
      </CacheBuster>
    );
  }
}

export default App;
